import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '@codex/themes';
import TechnicalSpecificationSection from './TechnicalSpecificationSection';


const Table = styled.table`
  table-layout: auto;
  background: ${colors.shades[7]};
  border-collapse: collapse;
`;

export default function TechnicalSpecificationsTable({ productTechRequirementsList, highlightRowsWithDifferentValues }) {
  return (
    <Table>
      {
        productTechRequirementsList.map((technicalSpecificationSection) => (
          <TechnicalSpecificationSection
            key={technicalSpecificationSection.sectionLabel}
            sectionData={technicalSpecificationSection}
            highlightRowsWithDifferentValues={highlightRowsWithDifferentValues}
          />
        ))
      }
    </Table>
  );
}

TechnicalSpecificationsTable.propTypes = {
  productTechRequirementsList: PropTypes.arrayOf(
    PropTypes.shape({
      sectionLabel: PropTypes.string.isRequired,
      rows: PropTypes.arrayOf(PropTypes.shape({
        firstColumnLabel: PropTypes.string.isRequired,
        otherColumnsLabels: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
      }).isRequired
      ).isRequired
    }).isRequired
  ).isRequired,
  highlightRowsWithDifferentValues: PropTypes.bool
};

TechnicalSpecificationsTable.defaultProps = {
  highlightRowsWithDifferentValues: false
};
